import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getInviteDetail } from "../api/invite/memberServices";
import { UserInvite } from "../models/UserInvite";
import { useAuth } from "../context/AuthContext";
import Loader from "../components/Loader";
import LoadingPopup from "./channels/create/LoadingPopup";
import { SKArtifact } from "../models/SKArtifact";
import { SKChannel } from "../models/SKChannel";
import { Link } from "react-router-dom";
import { ShowChannelDetail } from "./channels/create/Preview";
import { getChannel } from "../api/channels/channelServices";

const Invitation = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [isInvitedUserLoggininUser, setIsInvitedUserLoggedInUser] = useState(false);
  const [canBeMember, setCanBeMember] = useState(true);
  const [invitation, setInvitation] = useState<UserInvite | null>(null);
  const authContext = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const getInvite = async (inviteId: string) => {
      setLoading(true);
      try {
        const data = await getInviteDetail(inviteId);
        const { firstName, lastName, email, channelId, channelName } = data;
        setInvitation(data);

        if (authContext?.isAuthenticated && authContext.currentUser?.email === email) {
          if (authContext?.myChannel) {
            setLoading(false);
            setCanBeMember(false);
            window.localStorage.removeItem("invitationId");
            return;
          }
          setIsInvitedUserLoggedInUser(true);
        } else {
          navigate("/", { state: { email, firstName, lastName } });
        }
      } catch (err) {
        setLoading(false);
      }
    };

    if (id) {
      window.localStorage.setItem("invitationId", id);
      getInvite(id);
    }
  }, [id]);

  useEffect(() => {}, [isInvitedUserLoggininUser, authContext]);

  return (
    <section>
      <LoadingPopup isLoading={loading} loadingText="Fetching detail.." />
      <div className="container">
        <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
          {/* Left Container */}
          <div className="flex flex-col items-start justify-start">
            <h1 className="herotitle">Skarvo</h1>
            <p className="text-xl font-normal">
              {invitation ? `You are invited to join the ${invitation?.channelName} channel.` : "No invitation found !!"}
            </p>
          </div>

          {/* Right Container */}
          <div className="flex flex-col items-center justify-center gap-10">
            <>
              {invitation && invitation.channelId ? (
                <ShowDetail channelId={invitation.channelId} isChannelMember={canBeMember} />
              ) : (
                <InvitationError
                  error="No Invitation found with this ID!!"
                  message="Either your invitation id is invalid or may be it has been expired"
                />
              )}
            </>
          </div>
        </div>
      </div>
    </section>
  );
};

interface DetailProps {
  channelId: string;
  isChannelMember: boolean;
}
const ShowDetail = ({ channelId, isChannelMember }: DetailProps) => {
  const [channel, setChannel] = useState<SKChannel | undefined>(undefined);

  useEffect(() => {
    const getDetail = async () => {
      const channel = await getChannel(channelId);
      setChannel(channel);
    };
    !isChannelMember && getDetail();
  }, []);

  return isChannelMember ? (
    <InvitationError
      error="You cannot join this channel"
      message="You can only be a member of one channel at any given time. Leave the existing channel to join this new channel"
    />
  ) : !channel ? (
    <LoadingPopup isLoading={true} loadingText="Fetching channel..." />
  ) : (
    <ShowChannelDetail channel={channel} />
  );
};

interface InvitationErrorProp {
  error: string;
  message: string;
}
const InvitationError = ({ error, message }: InvitationErrorProp) => {
  return (
    <div className="flex flex-col items-start formcard">
      <div className="flex flex-row items-start formheader">
        <div className="text-xl font-bold text-center">
          <img src={"/icons/Warning.png"} alt="Centered Content" className="mx-auto mb-4" />
        </div>
      </div>
      <div className="thickseparator"></div>
      <p className="formexplainertext">
        <strong>{error}</strong>
      </p>
      <p className="text-center formexplainertext">{message}</p>
      <div className="thickseparator"></div>
      <div className="w-full p-4 text-center">
        <Link to="#" onClick={() => {}} className="w-full w-button formsecondarybutton">
          Ok
        </Link>
      </div>
    </div>
  );
};

interface ChannelInviteProps {
  channel: SKChannel;
}
export const ShowChannelInvite = ({ channel }: ChannelInviteProps) => {
  return (
    <div className="p-1 bg-white">
      <div className="flex flex-col">
        <div className="mb-5 flex flex-col space-y-[10px] w-full">
          <div className="mb-5 flex flex-col space-y-[10px] min-w-[290px] min-h-[96px] max-w-[450px] max-h-[150px]">
            {/* {progress > 0 && <progress value={progress} max="100" />} */}
            {channel.backgroundImageUrl && (
              <img
                className="space-y-[10px] min-w-[290px] min-h-[96px] max-w-[450px] max-h-[150px]"
                style={{
                  borderColor: "grey",
                  borderWidth: "0.05rem",
                  borderStyle: "solid",
                  margin: "1px",
                }}
                //src="/icons/bannerimg.png"
                src={channel.backgroundImageUrl}
                alt=""
              />
            )}
          </div>
          <div className="mb-5 flex flex-col items-start min-w-[60px] min-h-[60px] max-w-[120px] max-h-[120px]  rounded-lg">
            {/* {progress > 0 && <progress value={progress} max="100" />} */}
            {channel.profileImageUrl && (
              <img
                style={{
                  borderColor: "grey",
                  borderWidth: "0.05rem",
                  borderStyle: "solid",
                  margin: "1px",
                  borderRadius: "6.375rem",
                }}
                //src="/icons/profileimg.png"
                src={channel.profileImageUrl}
                className="pr-1 pl-1 min-w-[60px] min-h-[60px] max-w-[120px] max-h-[120px]  rounded-lg"
                alt=""
              />
            )}
          </div>
          <div className="mb-5 flex flex-col space-y-[10px] w-full">
            <label className="block text-3xl font-semibold text-gray-900 dark:text-white">{channel.name}</label>
            <label className="block mb-2 text-sm font-semibold text-gray-400">{channel.topic}</label>
            <label className="block w-auto mb-2 text-sm font-medium text-black-400">{channel.description}</label>
          </div>
          <div className="w-full p-4 text-center">
            <Link to="#" onClick={() => {}} className="w-full w-button formprimarybutton">
              Ok
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invitation;
